module.exports = __webpack_public_path__ + "img/subscribe-logo.9e7b3e54.svg";